// extracted by mini-css-extract-plugin
export var actions = "_kw-d";
export var benefitCard = "_kw-a";
export var benefitIcon = "_kw-b";
export var benefitLabel = "_kw-c";
export var benefits = "_kw-9";
export var bodyText = "_kw-8";
export var closeButton = "_kw-2";
export var content = "_kw-3";
export var eyebrow = "_kw-4";
export var heading = "_kw-5";
export var image = "_kw-f";
export var imagePanel = "_kw-e";
export var modal = "_kw-0";
export var shell = "_kw-1";
export var title = "_kw-6";
export var titleOffer = "_kw-7";